import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMiViewScreenSelector from './MiViewScreenSelector.hook';
import {
  formControlStyle,
  selectStyle,
  inputLabelStyle,
  menuItemStyle,
  selectPaperStyle,
} from './MiViewScreenSelector.style';

import { ScreenSelectorProps } from './MiViewScreenSelector.types';

const MiViewScreenSelector: React.FC<ScreenSelectorProps> = ({
  minWidth,
  defaultValue,
  setNewScreen,
}) => {
  const { t } = useTranslation();
  const { handleChange, selectedValue, screens } = useMiViewScreenSelector(defaultValue, setNewScreen);

  return (
    <FormControl size="small" sx={ { ...formControlStyle, minWidth } }>
      <InputLabel sx={ inputLabelStyle }>
        { t('maya_miview_screen_dropdown_label') }
      </InputLabel>
      <Select
        sx={ selectStyle }
        size="small"
        value={ selectedValue }
        onChange={ handleChange }
        label={ t('maya_miview_screen_dropdown_label') }
        MenuProps={
          {
            PaperProps: {
              sx: { ...selectPaperStyle },
            },
          }
        }
      >
        {
          screens.map((screenId, index) => (
            <MenuItem key={ index } value={ screenId } sx={ menuItemStyle }>
              { screenId }
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};

export default MiViewScreenSelector;

